import { createElementBlock as o, openBlock as r, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return r(), o("svg", n, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.76 2.154a10.016 10.016 0 0 0-11.014 6.06A10 10 0 0 0 5.593 19.68a1 1 0 1 1-1.282 1.536A12 12 0 0 1 .895 7.456 12.016 12.016 0 0 1 14.11.186a1 1 0 0 1-.35 1.968M18.28 2.912a1 1 0 0 1 1.409-.127 12 12 0 0 1 3.424 13.739 12.006 12.006 0 0 1-13.439 7.25 1 1 0 1 1 .386-1.962A10.015 10.015 0 0 0 21.26 15.77 10 10 0 0 0 18.407 4.32a1 1 0 0 1-.127-1.408",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M16.016 5.77a1.1 1.1 0 0 0-.446-.07H9.075a1 1 0 0 0-.134 0h-.056v.005a1.069 1.069 0 0 0 0 2.125v.004h.043q.07.003.134 0h4.876l-3.997 9.058a1.164 1.164 0 0 0 .593 1.651 1.15 1.15 0 0 0 1.476-.639l4.625-10.767a1.074 1.074 0 0 0-.617-1.367z"
    }, null, -1)
  ]));
}
const c = { render: t };
export {
  c as default,
  t as render
};
//# sourceMappingURL=ic_7-C0rrbXwK.js.map
